import React, { useState } from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TableSortLabel,
  Pagination,
} from "@mui/material";
import "./port.css";
import JumboDdMenu from "@jumbo/components/JumboDdMenu/JumboDdMenu";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllPorts } from "app/redux/actions/masterAction";
import FullScreenLoader from "app/components/ListingPageLoader";

export default function ListPortTable({ searchTerm, setPage, page }) {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");

  const { portMaster, TotalPage, loading } = useSelector(
    (state) => state.masterReducer
  );
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSort = (property) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = portMaster?.sort((a, b) => {
    let aValue;
    let bValue;
    // console.log(orderBy);
    if (orderBy == "port_name") {
      aValue = a.port_name.toLowerCase();
      bValue = b.port_name.toLowerCase();
    }
    if (order === "desc") {
      return aValue < bValue ? -1 : 1;
    } else {
      return bValue < aValue ? -1 : 1;
    }
  });

  const handleItemAction = (menuItem) => {
    switch (menuItem.action) {
      case "edit":
        navigate("/master/port/edit", { state: menuItem?.data });
        break;
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getAllPorts(searchTerm, newPage));
  };

  return (
    <>
      {" "}
      {loading && <FullScreenLoader />}
      <TableContainer component={Paper} sx={{ width: "100%" }}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
              <TableCell
                sx={{
                  textAlign: "left",
                }}
              >
                <TableSortLabel
                  active={orderBy === "port_name"}
                  direction={order}
                  onClick={() => handleSort("port_name")}
                  sx={{
                    minxWidth: "100px",
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white", // Set the color for the active state
                    },
                  }}
                >
                  Port Name
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                }}
              >
                <TableSortLabel
                  active={orderBy === "sales_person_full_name"}
                  direction={order}
                  onClick={() => handleSort("sales_person_full_name")}
                  sx={{
                    minxWidth: "100px",
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white", // Set the color for the active state
                    },
                  }}
                >
                  Sales Person Name
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  color: "white",
                }}
              >
                Port No
              </TableCell>
              {permissions?.port_master_edit == true && (
                <TableCell
                  sx={{
                    textAlign: "left",
                    color: "white",
                  }}
                >
                  Action
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData?.map((row, i) => (
              <TableRow key={i}>
                <TableCell sx={{ textAlign: "left" }}>
                  {row.port_name}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row.sales_person_full_name || "-"}
                </TableCell>

                <TableCell sx={{ textAlign: "left" }}>{row.port_no}</TableCell>
                {permissions?.port_master_edit == true && (
                  <TableCell sx={{ textAlign: "left" }}>
                    <JumboDdMenu
                      icon={<MoreHorizIcon />}
                      menuItems={[
                        {
                          icon: <EditIcon />,
                          title: "Edit Port Details",
                          action: "edit",
                          data: row,
                        },
                      ]}
                      onClickCallback={handleItemAction}
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Pagination
          count={TotalPage || 1}
          page={page}
          onChange={handleChangePage}
          sx={{
            position: "sticky",
            bottom: 0,
            left: 0,
            backgroundColor: "white",
            borderTop: "1px solid #ddd",
          }}
        />
      </TableContainer>
    </>
  );
}
